import HeroCarousel from "./HeroCarousel";
import KnowledgeAndDisclaimer from "./KnowledgeAndDisclaimer";
import OnboardSection from "./OnboardSection";
import PartnerSection from "./PartnerSection";
import ReviewSection from "./ReviewSection";
import ServicesSection from "./ServiceSection";
import SetupBusinessSection from "./SetupBusineddSection";
import VideoSection from "./VideoSection";
import WhyUsSection from "./WhyUsSection";

const HomeScreen = () => {
  return (
    <>
      <HeroCarousel />
      <ServicesSection />
      <WhyUsSection />
      <VideoSection />
      <OnboardSection />
      <SetupBusinessSection />
      <ReviewSection />
      <PartnerSection />
      <KnowledgeAndDisclaimer />
    </>
  );
};
export default HomeScreen;
